import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { type FieldSuggestion } from 'hb-react/shared/components/AIFormWidget/types';

interface FooterProps {
  acceptAllSuggestions: () => void;
  resetSuggestions: () => void;
  suggestions: Array<FieldSuggestion>;
}

export const Footer = ({
  suggestions = [],
  acceptAllSuggestions,
  resetSuggestions,
}: FooterProps) => {
  if (suggestions.length === 0) {
    return null;
  }

  const pendingSuggestions = suggestions.filter(
    (suggestion) => suggestion.status === 'pending',
  );

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      width="100%"
      gridColumnGap={3}
    >
      {pendingSuggestions.length > 0 && (
        <Button
          variant="primary"
          onClick={acceptAllSuggestions}
          aria-label={s__('AIForm|Accept all %{count} pending suggestions').i__(
            { count: String(pendingSuggestions.length) },
          )}
        >
          {s__('AIForm|Accept all')}
        </Button>
      )}
      <Button
        variant="secondary"
        onClick={resetSuggestions}
        aria-label={s__('AIForm|Clear all suggestions')}
      >
        {s__('AIForm|Restart')}
      </Button>
    </Box>
  );
};
